module.exports = __webpack_public_path__ + "static/media/question-circle.feda1f21.svg";